import { render, staticRenderFns } from "./text_limit.vue?vue&type=template&id=d0b350a6"
import script from "./text_limit.js?vue&type=script&lang=js&external"
export * from "./text_limit.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports